import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import Switch from 'react-switch';
import './style.scss';

interface PropsType {
    checked?: boolean;
    onChange: Function;
    disabled?: boolean;
}

const AfSwitch = ({ checked, onChange, disabled = false }: PropsType) => {
    const { colors } = useSelector((state: ApplicationState) => state.appOrganization.data);

    const handleChange = () => {
        onChange(!checked);
    };

    return (
        <Switch
            checked={!!checked}
            checkedIcon={false}
            disabled={disabled}
            handleDiameter={20}
            height={14}
            offColor="#d1d1d1"
            offHandleColor="#b3b3b3"
            onChange={handleChange}
            onColor={colors[0]}
            onHandleColor={colors[0]}
            uncheckedIcon={false}
            width={30}
        />
    );
};

export default AfSwitch;
